import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsGuarantor({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 18 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M3.62 8.9a4.6 4.6 0 004.01 0h.25q.31 0 .62.06v.54c.02 1.83.19 2.71.53 3.7.19.53.61.93 1.06 1.3q-.12.03-.25.02H1.41A1.4 1.4 0 010 13.12v-.85A3.4 3.4 0 013.38 8.9zm2-7.4a3.28 3.28 0 110 6.56 3.28 3.28 0 010-6.56" />
      <path
        fillRule="evenodd"
        d="M12.06 12.74l-1.1-1.05a.16.16 0 010-.23l.24-.23a.2.2 0 01.24 0l.74.7 1.58-1.5a.2.2 0 01.24 0l.24.22c.06.06.06.17 0 .23l-1.94 1.86a.2.2 0 01-.24 0m.54-4.61l3.37 1.22s.03 3-.82 4.05a12 12 0 01-2.55 2.04m0-7.31L9.23 9.35s-.03 3 .82 4.05a12 12 0 002.55 2.04"
        clipRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsGuarantor.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsGuarantor.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsGuarantor svgRef={ref} {...props} />
));
export default ForwardRef;
